import EditSectionModal from "../../components/EditSectionModal";
import { getAllTrainers, updateTrainersSection } from "../../services/trainers";

const EditTrainerSectionModal = function () {
  return (
    <EditSectionModal
      config={{
        entityName: "Athlete",
        entityNamePlural: "Athletes",
        fetchItems: (params) => getAllTrainers({ params }),
        saveSection: updateTrainersSection,
        responseKey: "trainers",
      }}
    />
  );
};

export default EditTrainerSectionModal;
